import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Link } from 'react-router-dom';

const DEFAULT_FORM = {
    question: "",
    answer: ""
}

const FAQ = () => {

    const [form, setForm] = useState(DEFAULT_FORM)
    const [editForm, setEditForm] = useState(false)
    const [editItemId, setEditItemId] = useState(0)


    const { addData: addFAQ } = useEntityCrud("Info/SetFaq")
    const { addData: updateFAQ } = useEntityCrud("Info/UpdateFaq")
    const { readDataGet } = useEntityCrud('Info/GetFaq');
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        readDataGet().then(({ data }) => {
            if (data.status)
                setData(data.result)
        });
    }


    const handleChange = (e) => {
        const newForm = { ...form };
        newForm[e.target.name] = e.target.value
        setForm(newForm)
    }

    function handleSubmit(e) {
        debugger
        e.preventDefault();

        if (!editForm) {
            debugger
            const body = {
                "question": form.question,
                "answer": form.answer
            }
            addFAQ(body)
                .then(({ data }) => {
                    debugger
                    if (data.status) {
                        toast.success('عملیات مورد نظر با موفقیت انجام شد');
                        setForm(DEFAULT_FORM)
                        getData();
                    } else
                        data.errors.map(error => toast.error(error.message));
                })
        }
        else {
            debugger
            const body = {
                "question": form.question,
                "answer": form.answer,
                "id": editItemId
            }
            updateFAQ(body)
                .then(({ data }) => {
                    debugger
                    if (data.status) {
                        toast.success('عملیات مورد نظر با موفقیت انجام شد');
                        setForm(DEFAULT_FORM)
                        getData();
                    } else
                        data.errors.map(error => toast.error(error.message));
                })
        }
    }



    return (
        <div className="card">
            <div className="card-header"><div className="card-title">پرسش و پاسخ</div></div>
            <div className="card-body">
            <div className=" baseInfo_" >
                <form onSubmit={handleSubmit} >
                    <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>
                        <div className="col-md-12 pr-0">
                            <div className="form-group">
                                <label>  سوال  </label>
                                <input value={form.question} name={"question"} onChange={handleChange} type="text"
                                    className="form-control mt-0" />
                            </div>
                        </div>
                        <div className="col-md-12 pr-0">
                            <div className="form-group">
                                <label>  جواب  </label>
                                <textarea value={form.answer} name={"answer"} onChange={handleChange} type="text"
                                    className="form-control mt-0" />
                            </div>
                        </div>
                        <div className="col-md-12 mt-1">
                            <div className="form-group mb-0">
                                <button className="btn btn-success px-4 btn-block" disabled={form.question !== "" && form.answer !== "" ? false : true}>ذخیره اطلاعات </button>
                            </div>
                        </div>
                    </div>ّ
                </form>
            </div>


            <hr className="mt-4" />

            <div class="  my-4">

                <div class="alert alert-info" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                    <i class="fa fa-list me-2" aria-hidden="true">
                    </i>     تمامی سوالات ثبت شده را می توانید در لیست زیر مشاهده کنید.
                </div>

                <div class="accordion" id="accordionExample">
                    {data?.filter(item => item.answer !== null).map((item, index) => (
                        <div class="accordion-item">
                            <h2 class="accordion-header d-flex  " id={`headingOne${index}`}>
                                <button class="accordion-button collapsed" type="button"
                                    onClick={() => setForm({ question: "", answer: "" })}
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    data-bs-target={`#collapseOne${index}`}
                                    aria-controls={`collapseOne${index}`}>
                                    {index + 1} - {item.question}
                                </button>
                                <a class="btn btn-primary m-2 p-1" type="button" onClick={() => {
                                    setEditForm(true)
                                    setForm({ question: item.question, answer: item.answer })
                                    setEditItemId(item.id)
                                }
                                } >
                                    <i className='fa fa-edit'></i>
                                </a>
                            </h2>
                            <div id={`collapseOne${index}`} class="accordion-collapse collapse px-4 mx-4" aria-labelledby={`headingOne${index}`} data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    {item.answer}
                                </div>
                            </div>
                        </div>
                    ))
                    }
                </div>
            </div>
        </div>
    </div>

    );
};


export default FAQ;